import React, { useRef, useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import { AppUrls } from 'common/AppUrls'
import { useRouteMatch } from 'react-router'
import cn from 'classnames'
import { WhitelabelConfig } from 'hooks'

export function AppContainer({ children }) {
    const containerRef = useRef(null)

    const matchCall = useRouteMatch(AppUrls.call)
    const matchCallerInsights = useRouteMatch(AppUrls.callerInsights)

    const isOnCall = matchCall || matchCallerInsights
    const isDefault = WhitelabelConfig.key === 'default'

    useEffect(() => {
        if (containerRef?.current) {
            sessionStorage.setItem('appHeight', containerRef.current.getBoundingClientRect().height)
        }
    }, [containerRef])

    return (
        <div ref={containerRef} className={cn('app__container', isMobile && 'is-mobile', isOnCall && 'is-on-call', !isDefault && `whitelabel-${WhitelabelConfig.key}`)}>
            {children}
        </div>
    )
}
